import { Col, Row, Card, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { useAlert } from "../../context/AlertContext";
import ConfirmModal from "../ConfirmModal";
import SignaturePad from 'react-signature-canvas'
import FileUploadsService from "../../services/fileupload.service";
import TechWorkClosedService from "../../services/techworkclose.service";
import { addEditServiceRequest } from "../../commons/ServiceRequest";
import { useLoading } from "../../context/LoadingContext";
import { useNavigate } from "react-router-dom";

export default function SignJob({ data, setIsAccept, destination }) {
  const [showModal, setShowModal] = useState(false)
  const [trimmedDataURL, setTrimmedDataURL] = useState("")
  const signPad = useRef(null);
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const navigate = useNavigate();

  const trim = () => {
    setTrimmedDataURL(signPad.current.getTrimmedCanvas().toDataURL('image/png'))
  }

  async function handleSubmit() {
    // trim()
    const base64 = signPad.current.getTrimmedCanvas().toDataURL('image/png')

    var arr = base64.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], "sign.png", { type: mime });

    const res = await FileUploadsService.createFileUploads(destination, [file])
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechWorkClosedService.createTechWorkClose({
        "tech_plan_id": data.tech_plan_id,
        "tech_work_close_date": new Date(),
        "seq_status_id": 3, //
        "cus_accepted": true,
        "cus_signed_date": new Date(),
        "tech_work_close_file": {
          "file_path": res.files[0],
          "file_type": "Image"
        }
      }),
      navigated: () => navigate("/service_work/perform", {
        state: { name: "CloseJob" }
      })
    });

  }

  return (<>
    <Card className="m-1 mb-4 p-4 border-0">

      <div className="sign">
        <SignaturePad ref={signPad} />
      </div>

      <Row className="justify-content-center mt-4">
        <Col className="col-auto">
          <Button
            variant="success"
            className="me-2 ms-3 mb-3 py-2 px-5 text-dark rounded-pill"
            onClick={handleSubmit}
          >
            เซ็นต์รับงาน
          </Button>
          <ConfirmModal
            show={showModal}
            content={"add"}
          // onSubmitCallback={submit}
          />

          <Button
            variant="outline-secondary"
            className="ms-2 px-5 mb-3 py-2 text-dark border-dark border-opacity-50 rounded-pill"
            onClick={() => signPad.current.clear()}
          >
            ยกเลิก
          </Button>
        </Col>
      </Row>

    </Card>
    <Card className="m-1 mb-4 p-4 border-0">
      <center>
        <Button
          variant="outline-secondary"
          className="ms-2 px-5  py-2 text-dark border-dark border-opacity-50 rounded-pill"
          onClick={() => setIsAccept(false)}
        >
          ย้อนกลับ
        </Button>
      </center>
    </Card>
  </>)
}

SignJob.propTypes = {
  data: PropTypes.object,
  setIsAccept: PropTypes.func,
  destination: PropTypes.string
};